import { Box, Container, Heading, List, ListIcon, ListItem, Text, VStack, Code } from '@chakra-ui/react'
import { FiCheck } from 'react-icons/fi'

export const ApiPlatformPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="xl" color="brand.500" mb={3}>
            API: платформа и интеграции
          </Heading>
          <Text color="gray.600">
            Служебные и интеграционные части API: тарифы, подписки, уведомления, realtime.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Группы эндпоинтов</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/tariffs</Code> — тарифные планы и ограничения.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/subscription</Code> — подписка, статус, период.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/notifications</Code> — пользовательские уведомления.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/announcements</Code> — системные объявления.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/ws</Code> — WebSocket realtime-каналы.</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
